import { render, staticRenderFns } from "./AbandonedCheckout.vue?vue&type=template&id=352e797a&"
import script from "./AbandonedCheckout.vue?vue&type=script&lang=js&"
export * from "./AbandonedCheckout.vue?vue&type=script&lang=js&"
import style0 from "./AbandonedCheckout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports